var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
export var ApAutocomplete = function (props) {
    var name = props.name;
    var selectedValue = props.options.find(function (opt) { return opt.value === props.formik.values[name]; }) || null;
    return (_jsx(Autocomplete, { value: selectedValue, disablePortal: true, disableCloseOnSelect: props.disableCloseOnSelect, multiple: props.multiple, limitTags: props.limitTags, options: props.options, isOptionEqualToValue: function (option, value) { return option.value === value.value; }, sx: props.autocompleteSx, fullWidth: props.fullWidth, size: props.size, renderInput: function (params) {
            return _jsx(TextField, __assign({}, params, { label: props.label, error: props.formik.touched[name] && Boolean(props.formik.errors[name]), helperText: (props.formik.touched[name] && props.formik.errors[name]) || " ", onBlur: props.formik.handleBlur }));
        }, onChange: function (e, value) {
            props.formik.setFieldValue(name, value ? value.value : null);
        } }));
};
